/**
 * Meta (Facebook) Pixel condicionado ao consentimento de marketing.
 * Não carrega no page load: só injeta o fbevents + init + PageView quando o
 * usuário aceita a categoria de marketing no banner (ou já aceitou numa visita
 * anterior — lê o cookie cc_cookie). Assim, sem consentimento, nenhum cookie/
 * requisição do Facebook é criada (LGPD + Best Practices).
 *
 * Exposto como window.loadFacebookPixelOnConsent() — chamado pelo cookieconsent.js.
 */
(function () {
    var loaded = false;

    function loadPixel() {
        if (loaded) return;
        var id = window.__FB_PIXEL_ID__;
        if (!id) return;
        loaded = true;

        // bootstrap padrão do Meta Pixel
        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
            if (!f._fbq) f._fbq = n;
            n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
            t = b.createElement(e); t.async = !0; t.src = v;
            s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

        window.fbq("init", id);
        window.fbq("track", "PageView");
    }

    // API chamada pelo cookieconsent quando o consentimento é concedido
    window.loadFacebookPixelOnConsent = loadPixel;

    // Visitante que já aceitou antes: dispara já no load
    try {
        var m = document.cookie.match(/(?:^|;\s*)cc_cookie=([^;]+)/);
        if (m) {
            var cc = JSON.parse(decodeURIComponent(m[1]));
            var lvl = cc.level || cc.categories || [];
            if (lvl.indexOf("marketing_cookies") !== -1) loadPixel();
        }
    } catch (e) {}
})();
